module.exports = __webpack_public_path__ + "static/media/nn-spoonerism-Cinstructions.9f86dea5.mp3";